import { FormControl } from '@angular/forms';
import { ApplianceDetailsSteppedMultiPlanFormField } from './appliance-details-stepped-multi-plan-form-field.enum';

export interface ApplianceDetailsSteppedMultiPlanForm {
  [ApplianceDetailsSteppedMultiPlanFormField.BrandCode]: FormControl<
    string | null
  >;
  [ApplianceDetailsSteppedMultiPlanFormField.ApplianceCodeBuiltIn]: FormControl<
    boolean | null
  >;
  [ApplianceDetailsSteppedMultiPlanFormField.PurchaseDate]: FormControl<Date | null>;
  [ApplianceDetailsSteppedMultiPlanFormField.PurchasePrice]: FormControl<
    number | null
  >;
}
